import { ShowTourBanner } from 'ducks/tour'
import { PartnerIdType } from 'pages/auth/sso/types'
import { MFAConfigType } from './mfa'
import { OrgBrief } from './orgs'
import { RoleType } from './roles'
import type { StaffPermissions } from './staffPermissions'
export type { StaffPermissions, StaffPermissionKey } from './staffPermissions'
export { STAFF_PERMISSION_LABELS } from './staffPermissions'

export type AuthStatus =
  | 'undetermined'
  | 'sso_logging_in'
  | 'reloading'
  | 'os_logging_in'
  | 'auto_logging_in'
  | 'os_registering'
  | 'authenticated'

export interface AuthState extends AuthType {
  loadedFromLocalStorage?: boolean
  autoLoginProject?: number
  status?: AuthStatus
  reloading?: boolean

  // MFA
  mfaCheckRequired: boolean
  mfaConfigRequired: boolean
  mfaCodesShowing: boolean
  mfaHasSms: boolean
  mfaHasTotp: boolean
  mfaHasRecovery: boolean
  mfaConfig?: MFAConfigType
  contact_org_id?: number
}

// These props get omitted from local storage
export const AUTH_STATE_EPHEMERAL_PROPS = [
  'loadedFromLocalStorage',
  'autoLoginProject',
  'reloading',
  'mfaCheckRequired',
  'mfaConfigRequired',
  'mfaCodesShowing',
  'mfaHasSms',
  'mfaHasTotp',
  'mfaHasRecovery',
  'status',
]

export interface AuthUserType {
  id: number
  email: string
  phone?: string
  login_authority?: LoginAuthority
  external_account_id?: string
  email_marketing_opt_in: boolean
  phone_is_verified: boolean
  email_is_verified: boolean
  is_mfa_enabled: boolean
  show_tour_banner?: ShowTourBanner
  is_anonymous_share_user?: boolean
  paired_partners: PairedPartners
}

type PairedPartners = {
  [key in PartnerIdType]: {
    partner_user_uuid: string
    pair_metadata: {
      email: string
    }
  }
}

export interface AuthExhibitorType {
  id: number
  name: string
  logo_public_url: string
  component_types: number[]
}

export interface AuthType {
  OPENSOLAR_API_VERSION: string
  token: string | undefined
  user: AuthUserType
  org_id: number
  orgs: OrgBrief[]
  exhibitors: AuthExhibitorType[]
  is_staff: boolean
  is_superuser: boolean
  is_machine_user: boolean
  roles: RoleType[]
  terms_accepted_date: string // ISO8601: 2022-08-04T02:56:55.419768+00:00
  api_key_google: string
  staff_access_countries_csv?: string
  ad_intensity?: number
  staff_permissions?: StaffPermissions
}

export type LoginAuthority = 'nearmap' | 'os_jwt'
